import { render } from "./Downloadlist.vue?vue&type=template&id=502e4c9f&scoped=true"
import script from "./Downloadlist.vue?vue&type=script&lang=js"
export * from "./Downloadlist.vue?vue&type=script&lang=js"

import "./Downloadlist.vue?vue&type=style&index=0&id=502e4c9f&scoped=true&lang=css"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502e4c9f"]])

export default __exports__